/*
 * NicheCanvas: one shared /cart.js read for the theme's UpCart drawer scripts (TH-52).
 * nc-drawer-minmax.js and nc-drawer-tracking.js react to the same drawer renders and used to
 * fetch /cart.js separately each time. read() joins a read that is already in flight instead of
 * sending a second one; subscribe() hands every cart a read returns to scripts that only need to
 * look at it. Nothing is cached once a read has settled: the next read goes to the network.
 * A read that started before UpCart reported a cart change is never joined (see invalidate).
 * Loaded before its users via snippets/nc-frame-upsell.liquid; each user keeps its own fetch as
 * a fallback when this file is missing.
 */
(function () {
  'use strict';

  if (window.NCDrawerCart) return;

  var inFlight = null;
  var listeners = [];

  function notify(cart) {
    listeners.slice().forEach(function (listener) {
      try { listener(cart); } catch (e) {}
    });
  }

  // A read still out after this long is treated as lost (a dropped connection can leave a fetch
  // pending for minutes): later readers start a new one instead of waiting on it.
  var MAX_JOIN_MS = 8000;

  function read() {
    if (inFlight && Date.now() - inFlight.started < MAX_JOIN_MS) return inFlight.promise;
    if (inFlight) inFlight.stale = true;
    var flight = { promise: null, started: Date.now() };
    flight.promise = fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
      .then(function (cart) {
        if (inFlight === flight) inFlight = null;
        if (!cart || !Array.isArray(cart.items)) throw new Error('bad cart');
        // The cart changed while this read was out (see invalidate), so its answer may be older than
        // the drawer: never show it. Its callers get a read that started after the change instead.
        if (flight.stale) return read();
        notify(cart);
        return cart;
      }, function (error) {
        if (inFlight === flight) inFlight = null;
        throw error;
      });
    inFlight = flight;
    return flight.promise;
  }

  // The cart changed after the read in flight may have started: later readers start a new one,
  // and that read's own answer is dropped when it lands (it may arrive after a newer one).
  function invalidate() {
    if (inFlight) inFlight.stale = true;
    inFlight = null;
  }

  function subscribe(listener) {
    if (typeof listener === 'function') listeners.push(listener);
  }

  window.NCDrawerCart = { read: read, subscribe: subscribe, invalidate: invalidate };

  var tries = 0;
  var poll = setInterval(function () {
    if (typeof window.upcartSubscribeCartUpdated === 'function') {
      clearInterval(poll);
      ['upcartSubscribeCartLoaded', 'upcartSubscribeCartUpdated'].forEach(function (fn) {
        if (typeof window[fn] === 'function') { try { window[fn](invalidate); } catch (e) {} }
      });
      return;
    }
    if (++tries > 100) clearInterval(poll);
  }, 300);
})();
